import { render } from "./AppPayNowStatus.vue?vue&type=template&id=4f963906&scoped=true"
import script from "./AppPayNowStatus.vue?vue&type=script&lang=js"
export * from "./AppPayNowStatus.vue?vue&type=script&lang=js"

import "./AppPayNowStatus.vue?vue&type=style&index=0&id=4f963906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f963906"]])

export default __exports__